import { render, staticRenderFns } from "./Question3.vue?vue&type=template&id=994e090c&scoped=true&"
import script from "./Question3.vue?vue&type=script&lang=js&"
export * from "./Question3.vue?vue&type=script&lang=js&"
import style0 from "./Question3.vue?vue&type=style&index=0&id=994e090c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994e090c",
  null
  
)

export default component.exports